define('views/filefinder/Podio.Views.FileFinderPermissionSettings',['require','lib/backbone/Backbone.PodioView','jst!filefinder/_permission_settings'],function(require) {

  var PodioView = require('lib/backbone/Backbone.PodioView');

  var jstPermissionSettings = require('jst!filefinder/_permission_settings');

  return PodioView.extend({

    podioEvents: {
      'click .cancel'                    : 'onCancelButtonClick',
      'click .done-update-permissions'   : 'onUpdatePermissionsButtonClick',
      'click .done-preserve-permissions' : 'onPreservePermissionsButtonClick',
      'click .done-always-ask'           : 'onAlwaysAskButtonClick'
    },

    initialize: function() {
      this._super();
    },

    render: function() {
      this.elm.html(this.getTemplate(jstPermissionSettings, {}));

      this.elm.appendTo(this.getOption('elmContainer'));

      if (!this.getOption('canPreservePermissions')) {
        this.elm.find('.done-preserve-permissions').hide();
      }
    },

    onCancelButtonClick : function(elmTarget, e) {
      e.stopPropagation();
      this.dispose();
      this.trigger('FileFinderPermissionSettings:cancel');
    },

    onUpdatePermissionsButtonClick: function(elmTarget, e) {
      this.dispose();
      this.trigger('FileFinderPermissionSettings:done', this.getOption('providerName'), false);
    },

    onPreservePermissionsButtonClick: function(elmTarget, e) {
      this.dispose();
      this.trigger('FileFinderPermissionSettings:done', this.getOption('providerName'), true);
    },

    onAlwaysAskButtonClick: function(elmTarget,e) {
      this.dispose();
      this.trigger('FileFinderPermissionSettings:done', this.getOption('providerName'), null);
    },
  });

});

